export const GET_PROJECT_START = 'GET_PROJECT_START';
export const GET_PROJECT_FAILED = 'GET_PROJECT_FAILED';
export const GET_PROJECT_SUCCESS = 'GET_PROJECT_SUCCESS';
